export default __webpack_public_path__ + "static/media/icon_prestadores.ca642560.svg";